import { defineComponent as K, mergeModels as P, useModel as Q, useTemplateRef as I, ref as m, computed as N, watch as k, onMounted as W, onBeforeUnmount as X, createElementBlock as d, createCommentVNode as f, openBlock as i, mergeProps as Y, unref as a, createVNode as y, createBlock as V, normalizeClass as n, withCtx as v, createElementVNode as D, createSlots as O, renderSlot as A, resolveDynamicComponent as w, normalizeStyle as Z, createTextVNode as z, toDisplayString as B } from "vue";
import t from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Alert/alert.js";
import { c_alert__title_max_lines as _ } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_alert__title_max_lines.js";
import x from "../../helpers/PassThrough.vue2.js";
import ee from "../Tooltip/Tooltip.vue2.js";
import ae from "../Button.vue2.js";
import te from "../CloseButton.vue2.js";
import oe from "./AlertIcon.vue2.js";
import { AngleRightIcon as ie } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { useOUIAProps as le } from "../../helpers/ouia.js";
import { useElementSize as ne } from "@vueuse/core";
const se = ["aria-live", "aria-atomic"], re = { class: "pf-v6-screen-reader" }, be = /* @__PURE__ */ K({
  name: "PfAlert",
  __name: "Alert",
  props: /* @__PURE__ */ P({
    ariaLabel: {},
    id: {},
    expandable: { type: Boolean },
    onClose: {},
    inline: { type: Boolean },
    liveRegion: { type: Boolean },
    plain: { type: Boolean },
    timeout: { type: [Number, Boolean] },
    timeoutAnimation: { default: 3e3 },
    title: {},
    component: { default: "h4" },
    toggleAriaLabel: {},
    tooltipPosition: { default: "auto" },
    truncateTitle: { default: 0 },
    variant: { default: "custom" },
    variantLabel: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ P(["mouseenter", "mouseleave", "timeout"], ["update:expanded"]),
  setup(C, { emit: H }) {
    const o = C, U = le({ id: o.ouiaId, safe: o.ouiaSafe, variant: o.variant }), s = Q(C, "expanded"), T = H, p = I("title"), { width: F, height: G } = ne(p), c = m(!1);
    let h, $;
    const r = m(!1), M = m(!1), u = m(!0), l = m(!1), j = I("elRef"), L = N(() => `${o.variant.charAt(0).toUpperCase()}${o.variant.slice(1)} alert:`), b = N(() => M.value && u.value && !r.value && !l.value);
    k(() => [F.value, G.value], () => {
      if (!(p.value instanceof HTMLElement) || !o.truncateTitle)
        return !1;
      c.value = p.value.offsetHeight < p.value.scrollHeight;
    }), k(b, () => {
      b.value && T("timeout");
    }), W(() => {
      o.timeout && (h = setTimeout(() => M.value = !0, o.timeout === !0 ? 8e3 : o.timeout)), document.addEventListener("focus", E, !0), k(() => [l.value, r.value], () => {
        !l.value && !r.value ? $ = setTimeout(() => u.value = !0, o.timeoutAnimation) : (clearTimeout($), u.value = !1);
      });
    }), X(() => {
      clearTimeout(h), clearTimeout($), document.removeEventListener("focus", E, !0);
    });
    function E() {
      var e;
      (e = j.value) != null && e.contains(document.activeElement) ? (l.value = !0, u.value = !1) : l.value && (l.value = !1);
    }
    function q(e) {
      r.value = !0, u.value = !1, T("mouseenter", e);
    }
    function J(e) {
      r.value = !1, T("mouseleave", e);
    }
    return (e, g) => b.value ? f("", !0) : (i(), d("div", Y({ key: 0 }, a(U), {
      ref: "elRef",
      class: [
        a(t).alert,
        a(t).modifiers[e.variant],
        {
          [a(t).modifiers.inline]: e.inline,
          [a(t).modifiers.plain]: e.plain,
          [a(t).modifiers.expandable]: e.expandable,
          [a(t).modifiers.expanded]: s.value
        }
      ],
      "aria-live": e.liveRegion ? "polite" : void 0,
      "aria-atomic": e.liveRegion ? "false" : void 0,
      onMouseenter: q,
      onMouseleave: J
    }), [
      e.expandable ? (i(), d("div", {
        key: 0,
        class: n(a(t).alertToggle)
      }, [
        y(ae, {
          variant: "plain",
          "aria-expanded": s.value,
          "aria-label": e.toggleAriaLabel || `Toggle ${L.value} ${e.title}`,
          onClick: g[0] || (g[0] = (R) => s.value = !s.value)
        }, {
          default: v(() => [
            D("span", {
              class: n(a(t).alertToggleIcon)
            }, [
              y(a(ie), { "aria-hidden": "" })
            ], 2)
          ]),
          _: 1
        }, 8, ["aria-expanded", "aria-label"])
      ], 2)) : f("", !0),
      y(oe, { variant: e.variant }, O({ _: 2 }, [
        e.$slots["custom-icon"] ? {
          name: "default",
          fn: v(() => [
            A(e.$slots, "custom-icon")
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["variant"]),
      (i(), V(w(c.value ? ee : x), { position: e.tooltipPosition }, O({
        default: v(() => [
          (i(), V(w(e.component), {
            ref: "title",
            class: n([a(t).alertTitle, {
              [a(t).modifiers.truncate]: e.truncateTitle
            }]),
            style: Z(e.truncateTitle ? `${a(_).name}: ${e.truncateTitle}` : null),
            tabindex: c.value ? "0" : null
          }, {
            default: v(() => [
              D("span", re, B(L.value), 1),
              z(" " + B(e.title), 1)
            ]),
            _: 1
          }, 8, ["class", "style", "tabindex"]))
        ]),
        _: 2
      }, [
        c.value ? {
          name: "content",
          fn: v(() => [
            z(B(e.title), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["position"])),
      e.onClose ? (i(), d("div", {
        key: 1,
        class: n(a(t).alertAction)
      }, [
        y(te, {
          onClick: g[1] || (g[1] = (R) => {
            var S;
            return (S = e.onClose) == null ? void 0 : S.call(e, R);
          })
        })
      ], 2)) : f("", !0),
      e.$slots.default && (!e.expandable || s.value) ? (i(), d("div", {
        key: 2,
        class: n(a(t).alertDescription)
      }, [
        A(e.$slots, "default")
      ], 2)) : f("", !0),
      e.$slots["action-links"] ? (i(), d("div", {
        key: 3,
        class: n(a(t).alertActionGroup)
      }, [
        A(e.$slots, "action-links")
      ], 2)) : f("", !0)
    ], 16, se));
  }
});
export {
  be as default
};
